import DashboardHome from "../views/DashboardHome.vue"

export default [
	{
		path: "/:tenantId/dashboard",
		component: DashboardHome,
		name: "DashboardHome",
		props: true,
		meta: { featureId: "dashboard" }
	}
]
